import React from "react";

const SidebarFooter = () => {
  return (
    <div className="siderbar_footer">
      © {new Date().getFullYear()}{" "}
      <a href="https://www.pathkindlabs.com/" target="_blank" rel="noreferrer">
        pathkindlabs.com
      </a>
      <br />
      Designed & Developed by
      <br />
      <a href="https://abym.in" target="_blank" rel="noreferrer">
        AbyM Technology.
      </a>
    </div>
  );
};

export default SidebarFooter;
